import React from 'react';
import classNames from 'classnames';
import { cloneDeep } from 'lodash';
import { tenantsModalCopy as copy } from '../../../copy/advisor-dashboard/tenants-tab.json';

export class DashboardButton extends React.Component {
  _isMounted = false;

  constructor(props) {
    super(props);
    this.state = {
      isDropdown: false,
      buttonLabel: '',
      buttonValue: '',
      subButtons: [],
      showDeleteConfirm: false,
      deleteTarget: null, // new
      deleteTargetType: null, // 'main' or 'sub'
    };
  }

  componentDidMount = () => {
    const { button } = this.props;

    if (button[0]) {
      if (Object.keys(button[0]).includes('labelEn')) {
        this.setState({
          buttonLabel: button[0].labelEn,
          buttonValue: button[0].value,
        });
      } else {
        this.setState({
          buttonLabel: button[0].dropdownLabelEn,
          subButtons: button[0].childButtons,
          isDropdown: true,
        });
      }
    }
  };

  componentDidUpdate(prevProps) {
    if (prevProps.button !== this.props.button) {
      const { button } = this.props;
      if (button[0]) {
        if (Object.keys(button[0]).includes('labelEn')) {
          this.setState({
            buttonLabel: button[0].labelEn,
            buttonValue: button[0].value,
          });
        } else {
          this.setState({
            buttonLabel: button[0].dropdownLabelEn,
            subButtons: button[0].childButtons,
            isDropdown: true,
          });
        }
      }
    }
  }

  handleInputChange = (id, e) => {
    this.setState({
      [id]: e,
    });
  };

  handleIsDropdown = (currentVal) => {
    this.setState({
      isDropdown: !currentVal,
    });

    if (!currentVal && this.state.subButtons.length === 0) {
      this.addSubButton();
    }

    // removing dropdown button and placing normal one
    if (currentVal) {
      this.setState(
        {
          isDropdown: false,
          buttonLabel: this.state.buttonLabel,
          buttonValue: this.state.buttonValue,
          subButtons: [],
        },
        () => {
          // Ensure parent is updated after state is changed
          this.props.replaceDropdown(
            this.props.num,
            this.state.buttonLabel,
            this.state.buttonValue
          );
        }
      );
    }
  };

  labelAndInput = (id, label, className) => {
    return (
      <div className={classNames('tenant-modal__label-and-input', className)}>
        <label className="tenant-modal__label" htmlFor={id}>
          {label}
        </label>
        <input
          className="tenant-modal__input"
          id={id}
          value={this.state[id]}
          onChange={(e) => {
            this.handleInputChange(id, e.target.value);
          }}
          onBlur={(e) => {
            this.props.updateButtonOnParent(
              this.props.num,
              id === 'buttonLabel' ? 'labelEn' : 'value',
              e.target.value,
              this.state.isDropdown,
              this.state.subButtons,
              this.state.buttonLabel
            );
          }}
        />
      </div>
    );
  };

  checkboxAndLabel = (label) => {
    const { isDropdown } = this.state;
    return (
      <div className="tenant-modal__checkbox-and-label tenant-modal__margin-bottom">
        <input
          type="checkbox"
          className="tenant-modal__checkbox"
          name="terms-type"
          style={this.props.colorPrimary}
          id={label}
          onClick={() => {
            this.handleIsDropdown(isDropdown);
          }}
          tabIndex={0}
          onKeyDown={(e) => {
            if (['Enter'].includes(e.key)) this.handleIsDropdown(isDropdown);
          }}
          onChange={() => {
            // this is to appease react, but we want an onClick here
            // rather than an onChange - despite the fact that react
            // wants us to have an onChange
          }}
          checked={isDropdown}
        />
        <label
          htmlFor={label}
          className="tenant-modal__label tenant-modal__no-margin"
        >
          {label}
        </label>
      </div>
    );
  };

  subButtons = (id, label, className, i) => {
    return (
      <div className={classNames('tenant-modal__label-and-input', className)}>
        <label className="tenant-modal__label" htmlFor={`button-${i}-${id}`}>
          {label}
        </label>
        <input
          className="tenant-modal__input"
          id={`button-${i}-${id}`}
          value={this.state.subButtons[i][id]}
          onChange={(e) => {
            this.handleSubButtonsChange(id, e.target.value, i);
          }}
          onBlur={(e) => {
            this.props.updateButtonOnParent(
              this.props.num,
              id === 'buttonLabel' ? 'label' : 'value',
              e.target.value,
              this.state.isDropdown,
              this.state.subButtons,
              this.state.buttonLabel
            );
          }}
        />
      </div>
    );
  };

  handleSubButtonsChange = (id, e, i) => {
    console.log('🚀 ~ DashboardButton ~ id, e, i:', id, e, i);
    const { subButtons } = this.state;
    const clone = cloneDeep(subButtons);
    console.log('🚀 ~ DashboardButton ~ clone:', clone);
    clone[i][id] = e;
    clone[i].buttonNumber = this.props.num;
    this.setState({
      subButtons: clone,
    });
  };

  removeSubButton = (index) => {
    let noButtonsPresent = false;
    this.setState(
      (prevState) => {
        const updatedSubButtons = prevState.subButtons
          .filter((_, i) => i !== index)
          .map((btn, newIndex) => ({
            ...btn,
            order: newIndex + 2, // Reassign sequential order
          }));

        // if sub button is the last one in subButton then update paraent as
        if (updatedSubButtons.length === 0) {
          noButtonsPresent = true;
        }

        return {
          subButtons: updatedSubButtons,
          ...(noButtonsPresent ? { isDropdown: false } : {}),
        };
      },
      () => {
        if (noButtonsPresent) {
          // if sub button is the last one in subButton then update paraent as
          this.props.replaceDropdown(
            this.props.num,
            this.state.buttonLabel,
            this.state.buttonValue
          );
        } else {
          this.props.updateButtonOnParent(
            this.props.num,
            'subButtons',
            this.state.subButtons, // Now correctly updated
            this.state.isDropdown,
            this.state.subButtons,
            this.state.buttonLabel
          );
        }
      }
    );
  };

  displaySubButtons = () => {
    const { subButtons } = this.state;
    return subButtons?.map((button, i) => {
      return (
        <div
          className="tenant-modal__row tenant-modal__margin-bottom"
          key={`button-${this.props.buttonNumber}-${button.order}`}
          style={{ display: 'flex', gap: '10px', justifyContent: 'center' }}
        >
          {this.subButtons(
            `labelEn`,
            `${copy.subButtonLabel} ${i + 1} ${copy.dashButtonLabel2}`,
            'tenant-modal__leave-room',
            i,
            button.label
          )}
          {this.subButtons(
            `value`,
            `${copy.subButtonLabel} ${i + 1} ${copy.dashButtonLabel3}`,
            'tenant-modal__leave-room',
            i,
            button.value
          )}
          <div>
            <button
              type="button"
              tabIndex={0}
              onClick={() => this.toggleDeleteConfirm('sub', i)}
              // className="tenant-modal__remove-subbutton"
              style={{
                cursor: 'pointer',
                marginTop: '30px',
                background: 'none',
                border: 'none',
              }}
              onKeyDown={(e) => {
                if (['Enter'].includes(e.key))
                  this.toggleDeleteConfirm('sub', i);
              }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                x="0px"
                y="0px"
                width="15"
                height="15"
                viewBox="0 0 30 30"
              >
                <path d="M 7 4 C 6.744125 4 6.4879687 4.0974687 6.2929688 4.2929688 L 4.2929688 6.2929688 C 3.9019687 6.6839688 3.9019687 7.3170313 4.2929688 7.7070312 L 11.585938 15 L 4.2929688 22.292969 C 3.9019687 22.683969 3.9019687 23.317031 4.2929688 23.707031 L 6.2929688 25.707031 C 6.6839688 26.098031 7.3170313 26.098031 7.7070312 25.707031 L 15 18.414062 L 22.292969 25.707031 C 22.682969 26.098031 23.317031 26.098031 23.707031 25.707031 L 25.707031 23.707031 C 26.098031 23.316031 26.098031 22.682969 25.707031 22.292969 L 18.414062 15 L 25.707031 7.7070312 C 26.098031 7.3170312 26.098031 6.6829688 25.707031 6.2929688 L 23.707031 4.2929688 C 23.316031 3.9019687 22.682969 3.9019687 22.292969 4.2929688 L 15 11.585938 L 7.7070312 4.2929688 C 7.5115312 4.0974687 7.255875 4 7 4 z" />
              </svg>
            </button>
          </div>
        </div>
      );
    });
  };

  addSubButton = () => {
    const { subButtons } = this.state;
    const clone = cloneDeep(subButtons);
    clone.push({
      label: '',
      value: '',
      order: subButtons.length + 2,
      isDropdown: false,
    });
    this.setState({
      subButtons: clone,
    });
  };

  removeIndividualButton = (buttonNum) => {
    this.props.removeButton(buttonNum);
  };

  toggleDeleteConfirm = (type, index = null) => {
    if (type === 'main') {
      const { buttonLabel, buttonValue, isDropdown, subButtons } = this.state;
  
      if (isDropdown) {
        // Check if *any* sub button has a non-empty label or value
        const hasContent = subButtons.some(
          (btn) => btn.labelEn?.trim() || btn.value?.trim()
        );
  
        if (!hasContent) {
          // No content in any sub buttons, delete immediately
          this.props.removeButton(this.props.num);
          return;
        }
      } else {
        // Check if main buttonLabel or buttonValue has content
        const hasLabelOrValue = buttonLabel?.trim() || buttonValue?.trim();
        if (!hasLabelOrValue) {
          // Empty main button, delete immediately
          this.props.removeButton(this.props.num);
          return;
        }
      }
    } else if (type === 'sub') {
      const subButton = this.state.subButtons[index];
      const hasLabelOrValue = subButton?.labelEn?.trim() || subButton?.value?.trim();
      if (!hasLabelOrValue) {
        // Empty sub button, delete immediately
        this.removeSubButton(index);
        return;
      }
    }
  
    // Otherwise, show confirmation popup
    this.setState({
      showDeleteConfirm: true,
      deleteTarget: index,
      deleteTargetType: type,
    });
  };
  

  confirmDelete = () => {
    const { deleteTargetType, deleteTarget } = this.state;

    if (deleteTargetType === 'main') {
      this.props.removeButton(this.props.num);
    } else if (deleteTargetType === 'sub') {
      this.removeSubButton(deleteTarget);
    }

    this.setState({
      showDeleteConfirm: false,
      deleteTarget: null,
      deleteTargetType: null,
    });
  };

  cancelDelete = () => {
    this.setState({
      showDeleteConfirm: false,
      deleteTarget: null,
      deleteTargetType: null,
    });
  };

  render() {
    const { isDropdown } = this.state;
    return (
      <>
        <div className="tenant-modal__dashboard-button">
          <div
            className="tenant-modal__row tenant-modal__margin-bottom"
            style={{ display: 'flex', gap: '10px' }}
          >
            {this.labelAndInput(
              'buttonLabel',
              `${copy.dashButtonLabel1} ${this.props.num} ${copy.dashButtonLabel2}`,
              'tenant-modal__leave-room'
            )}
            {!isDropdown &&
              this.labelAndInput(
                'buttonValue',
                `${copy.dashButtonLabel1} ${this.props.num} ${copy.dashButtonLabel3}`,
                'tenant-modal__leave-room'
              )}

            {/* Remove button for individual button */}
            <div
              role="button"
              tabIndex={0}
              onClick={() => this.toggleDeleteConfirm('main')}
              className="tenant-modal__remove-subbutton"
              style={{
                cursor: 'pointer',
                marginTop: '32px',
                background: 'none',
                border: 'none',
              }}
              onKeyDown={(e) => {
                if (['Enter'].includes(e.key)) this.toggleDeleteConfirm('main');
              }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                x="0px"
                y="0px"
                width="15"
                height="15"
                viewBox="0 0 30 30"
              >
                <path d="M 7 4 C 6.744125 4 6.4879687 4.0974687 6.2929688 4.2929688 L 4.2929688 6.2929688 C 3.9019687 6.6839688 3.9019687 7.3170313 4.2929688 7.7070312 L 11.585938 15 L 4.2929688 22.292969 C 3.9019687 22.683969 3.9019687 23.317031 4.2929688 23.707031 L 6.2929688 25.707031 C 6.6839688 26.098031 7.3170313 26.098031 7.7070312 25.707031 L 15 18.414062 L 22.292969 25.707031 C 22.682969 26.098031 23.317031 26.098031 23.707031 25.707031 L 25.707031 23.707031 C 26.098031 23.316031 26.098031 22.682969 25.707031 22.292969 L 18.414062 15 L 25.707031 7.7070312 C 26.098031 7.3170312 26.098031 6.6829688 25.707031 6.2929688 L 23.707031 4.2929688 C 23.316031 3.9019687 22.682969 3.9019687 22.292969 4.2929688 L 15 11.585938 L 7.7070312 4.2929688 C 7.5115312 4.0974687 7.255875 4 7 4 z" />
              </svg>
            </div>
          </div>
          {this.checkboxAndLabel(copy.dashButtonCheckboxLabel)}
          {isDropdown && this.displaySubButtons()}
          {this.state.showDeleteConfirm && (
            <div className="tenant-modal__delete-modal-overlay">
              <div className="tenant-modal__confirm-modal">
                <p className="tenant-modal__confirm-text">
                  Are you sure you want to delete this
                  {' '}
                  <strong>
                    {this.state.deleteTargetType === 'main'
                      ? this.state.buttonLabel
                      : this.state.subButtons[this.state.deleteTarget]?.labelEn || `Sub Button ${this.state.deleteTarget + 1}`}
                  </strong>
                  {' '}
                  {this.state.deleteTargetType === 'main'
                    ? ' dashboard button'
                    : 'sub button'}
                  ?
                </p>
                <div className="tenant-modal__confirm-actions">
                  <button
                    type="button"
                    onClick={this.confirmDelete}
                    className="tenant-modal__button tenant-modal__button--danger"
                  >
                    Confirm
                  </button>
                  <button
                    type="button"
                    onClick={() => this.setState({ showDeleteConfirm: false })}
                    className="tenant-modal__button tenant-modal__button--cancel"
                  >
                    Cancel
                  </button>
                </div>
              </div>
            </div>
          )}

          {isDropdown && (
            <button
              onClick={this.addSubButton}
              tabIndex={0}
              type="button"
              onKeyDown={(e) => {
                if (['Enter'].includes(e.key)) {
                  this.addSubButton();
                }
              }}
              style={this.props.colorPrimary}
              className="tenant-modal__add-subbutton tenant-modal__margin-bottom"
            >
              {copy.addSubButton}
            </button>
          )}
        </div>
        <div className="tenant-modal__hr tenant-modal__margin-bottom" />
      </>
    );
  }
}
export default DashboardButton;
